import React from 'react'
import {Box} from '@chakra-ui/react3'
import {motion, useReducedMotion, useScroll, useTransform} from 'framer-motion'
import PropTypes from 'prop-types'
import {useRef} from 'react'

const Parallax = ({children, speed = 0.15}) => {
    const containerRef = useRef(null)
    const reducedMotionEnabled = useReducedMotion()

    const {scrollYProgress} = useScroll({
        target: containerRef,
        offset: ['start end', 'end start']
    })

    const y = useTransform(scrollYProgress, [0, 1], [`-${speed * 100}%`, `${speed * 100}%`])

    if (reducedMotionEnabled) {
        return children
    }

    return (
        <Box
            ref={containerRef}
            overflow="hidden"
            width="100%"
            height="100%"
            position="absolute"
            top="0"
            left="0"
        >
            <motion.div
                style={{
                    y,
                    width: '100%',
                    height: '130%',
                    position: 'absolute',
                    top: '-15%',
                    left: 0
                }}
            >
                {children}
            </motion.div>
        </Box>
    )
}

Parallax.propTypes = {
    children: PropTypes.node.isRequired,
    speed: PropTypes.number
}

export default Parallax
